import { render, staticRenderFns } from "./SelectLogisticsModal.vue?vue&type=template&id=6f0bc3fa&scoped=true"
import script from "./SelectLogisticsModal.vue?vue&type=script&lang=js"
export * from "./SelectLogisticsModal.vue?vue&type=script&lang=js"
import style0 from "./SelectLogisticsModal.vue?vue&type=style&index=0&id=6f0bc3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0bc3fa",
  null
  
)

export default component.exports